import { get } from 'vuex-pathify';

export default function safeGet(key, fallback) {
  // we need to use a function instead of a lambda because functions are scoped
  // differently and the value of 'this' is very delicate in this function.
  // eslint-disable-next-line func-names
  return function () {
    try {
      return get(key).bind(this)();
    } catch (e) {
      return fallback;
    }
  };
}
